export default __webpack_public_path__ + "static/media/4.3f0e34a5.png";